import { Link } from 'react-router-dom';
import { Shield, Wrench, LogIn, Mail, AlertTriangle } from 'lucide-react';
import './Landing.css';

export function Landing() {
    return (
        <div className="landing">
            <section className="landing-hero">
                <div className="hero-overlay" />
                <div className="hero-content">
                    <img
                        className="hero-logo"
                        src="/brand/logo-white.svg"
                        alt="Forest Town Ratepayers' Association"
                        width={320}
                        height={179}
                    />
                    <h1 className="hero-title">Welcome to the Forest Town Community Portal</h1>
                    <p className="hero-subtitle">
                        Your neighbourhood, connected. Stay informed, find trusted pros, and make your voice heard.
                    </p>
                    <div className="hero-actions">
                        <Link className="btn btn-primary btn-lg" to="/login">
                            <LogIn size={20} />
                            Sign In
                        </Link>
                        <Link className="btn btn-secondary btn-lg" to="/signup">
                            <Mail size={20} />
                            Request Access
                        </Link>
                    </div>
                </div>
            </section>

            <section className="landing-features">
                <div className="container">
                    <div className="features-grid">
                        <div className="feature-card animate-fade-in">
                            <div className="feature-icon">
                                <Shield />
                            </div>
                            <h3>Stay Informed</h3>
                            <p>
                                Community alerts, newsletters, security reports and meeting minutes in one place. Never miss an update about your neighbourhood.
                            </p>
                        </div>

                        <div className="feature-card animate-fade-in" style={{ animationDelay: '0.1s' }}>
                            <div className="feature-icon">
                                <Wrench />
                            </div>
                            <h3>Trusted Pros</h3>
                            <p>
                                Electricians, plumbers and gardeners recommended and rated by your neighbours.
                            </p>
                        </div>

                        <div className="feature-card animate-fade-in" style={{ animationDelay: '0.2s' }}>
                            <div className="feature-icon feature-icon-accent">
                                <AlertTriangle />
                            </div>
                            <h3>Report Issues</h3>
                            <p>
                                Log potholes, water leaks and streetlight outages, follow their progress, and escalate to the City when needed.
                            </p>
                        </div>
                    </div>
                </div>
            </section>

            <footer className="landing-footer">
                <div className="container">
                    <p>© {new Date().getFullYear()} Forest Town Community Portal. Built for residents, by residents. · <Link to="/privacy">Privacy</Link></p>
                </div>
            </footer>
        </div>
    );
}
